import React from 'react'
import { observer } from 'mobx-react'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogButton,
  DialogIllustration,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogButtonGroup,
} from 'components/Dialog'
import { Form, TextInputContainer, FormRow } from 'components/inputs'
import NewTeamModalViewModel from './NewTeamModalViewModel'
import ErrorBlock from 'components/ErrorBlock'
import { useBrandingSettings } from 'hooks/branding'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  newTeamVM: NewTeamModalViewModel
}

export default observer(function NewTeamModal({ newTeamVM }: Props) {
  const { corporateMode } = useBrandingSettings()
  return (
    <Dialog
      showing={newTeamVM.showing}
      onClose={!newTeamVM.createTeam.pending && newTeamVM.close}
    >
      <Form onSubmit={() => newTeamVM.createTeam()}>
        <DialogHeader>
          {!corporateMode && (
            <DialogIllustration
              src={require('./illustration.svg')}
              alt="Illustration of a group"
            />
          )}

          <DialogTitle>Create a new Team</DialogTitle>
          <DialogDescription>
            Looking to collaborate on work? Create a team to get started!
          </DialogDescription>
        </DialogHeader>
        <DialogContent>
          <FormRow>
            <TextInputContainer
              label="Team Name"
              field="name"
              model={newTeamVM}
              error={newTeamVM.validation.getError('name')}
              onBlur={newTeamVM.suggestSlug}
            />
          </FormRow>
          <FormRow>
            <TextInputContainer
              label="URL Slug"
              help="This field will indicate your unique identifier within this workspace. Must be alphanumerical including dashes (except at the beginning and end)"
              field="slug"
              error={newTeamVM.validation.getError('slug')}
              model={newTeamVM}
            />
          </FormRow>
        </DialogContent>
        {newTeamVM.createTeam.rejected && (
          <ErrorBlock
            tackOn="bottom"
            error={newTeamVM.createTeam.error}
            onCloseClick={() => newTeamVM.createTeam.reset()}
          />
        )}
        <DialogFooter bordered>
          <DialogButtonGroup>
            <DialogButton
              disabled={newTeamVM.createTeam.pending}
              onClick={newTeamVM.close}
            >
              Close
            </DialogButton>
            <DialogButton
              submit
              type="primary"
              loading={newTeamVM.createTeam.pending}
              disabled={newTeamVM.createTeam.pending}
            >
              Add
            </DialogButton>
          </DialogButtonGroup>
        </DialogFooter>
      </Form>
    </Dialog>
  )
})
